import Vue from 'vue'
// eslint-disable-next-line import/no-cycle
import router from '@/router/index'
// axios
import axios from 'axios'
// eslint-disable-next-line import/no-cycle
import {
  responseApi,
  requestApi,
  // requestApiForm,
} from '@/libs/secret'

// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
// const url = window.location.href
// const isWww = url.search('www')
// if (isWww > -1) endPoint = 'https://www.ioh.id/api/api/v1/'
// let endPoint = 'https://10.41.188.46:443/api/v1/'
// let endPoint = 'http://localhost:8000/api/v1/' // LOCAL
//let endPoint = 'http://117.54.4.124:23480/api/v1/' // INTERNAL
// let endPoint = 'https://triadscms-dev.gammasprint.com/api/api/v1/' // SIT
let endPoint = process.env.VUE_APP_BASE_URLS // UAT
// let endPoint = 'https://34.149.184.28:443/api/api/v1/' // PRODUCTION
const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'http://localhost:8000/api/v1/',
  // baseURL: 'https://demoapi.rctech.id/api/v1/',
  // baseURL: 'https://staging.ina17.com/api/',
  // baseURL: 'http://10.1.97.18:8082/api/v1/',
  baseURL: endPoint,
  // timeout: 1000,
  // headers: { Authorization: `Bearer ${store.state.datas.token}` },
})

axiosIns.interceptors.request.use(config => {
  if (config.method === 'get') {
    return config
  }
  const req = config
  req.data = requestApi(JSON.stringify(config.data))
  return req
}, error => Promise.reject(error.message))

axiosIns.interceptors.response.use(response => {
  const res = responseApi(response.data)
  if (res.original.code === 401) {
    localStorage.removeItem('vuex')
    router.push({ path: '/login' })
  }

  if (res.original.code === 404) {
    router.push({ path: '/error-404' })
  }

  res.data = res.original
  return res
}, error => {
  if (error.response && error.response.data) {
    if (error.response.status === 401) {
      localStorage.removeItem('vuex')
      router.push({ path: '/login' })
    }

    if (error.response.status === 404) {
      router.push({ path: '/error-404' })
    }

    return Promise.reject(error.response.data)
  }
  return Promise.reject(error.message)
})

Vue.prototype.$http = axiosIns

const axiosInsNoEnc = axios.create({
  // baseURL: 'http://localhost:8000/api/v1/',
  // baseURL: 'https://demoapi.rctech.id/api/v1/',
  // baseURL: 'https://staging.ina17.com/api/',
  baseURL: endPoint,
})

// axiosInsNoEnc.interceptors.request.use(config => {
//   if (config.method === 'get') {
//     return config
//   }
//   const req = config
//   req.data = requestApiForm(JSON.stringify(config.data))
//   return req
// }, error => Promise.reject(error.message))

axiosInsNoEnc.interceptors.response.use(response => {
  const res = responseApi(response.data)
  if (res.original.code === 401) {
    localStorage.removeItem('vuex')
    router.push({ path: '/login' })
  }

  if (res.original.code === 404) {
    router.push({ path: '/error-404' })
  }

  res.data = res.original
  return res
}, error => {
  if (error.response && error.response.data) {
    if (error.response.status === 401) {
      localStorage.removeItem('vuex')
      router.push({ path: '/login' })
    }

    if (error.response.status === 404) {
      router.push({ path: '/error-404' })
    }

    return Promise.reject(error.response.data)
  }
  return Promise.reject(error.message)
})

Vue.prototype.accessApi = axiosInsNoEnc

const axiosDefault = axios.create({
  baseURL: endPoint,
})

export { axiosInsNoEnc, axiosDefault }
export default axiosIns
